(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["renew-collection"] && !Shopify.designMode) return;
  try {
    
  const renewSort = document.querySelector('[data-sort]');
  if (renewSort) renewSort.addEventListener('change', () => renewSort.form.submit());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-creator-package"] && !Shopify.designMode) return;
  try {
    
  const renewPackage = document.querySelector('[data-package]');
  if (renewPackage) {
    const state = { lane: 'women', top: null, bottom: null, topLabel: '', bottomLabel: '', topPrice: 0, bottomPrice: 0 };
    const track = (event, details = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event, ...details});
    };
    const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const attribution = {};
    const currentParameters = new URLSearchParams(window.location.search);
    attributionKeys.forEach((key) => {
      const value = currentParameters.get(key) || window.sessionStorage.getItem(`renew_${key}`);
      if (!value) return;
      attribution[key] = value;
      window.sessionStorage.setItem(`renew_${key}`, value);
    });
    const storeAttribution = () => {
      if (!offerReady || !Object.keys(attribution).length) return;
      const attributes = Object.fromEntries(Object.entries(attribution).map(([key, value]) => [`Renew ${key}`, value]));
      fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({attributes})
      }).catch(() => {});
    };
    const tabs = renewPackage.querySelectorAll('[data-package-tab]');
    const lanes = renewPackage.querySelectorAll('[data-package-lane]');
    const progress = renewPackage.querySelector('[data-package-progress]');
    const review = renewPackage.querySelector('[data-package-review]');
    const itemSummary = renewPackage.querySelector('[data-package-items]');
    const retailSummary = renewPackage.querySelector('[data-package-retail]');
    const discountSummary = renewPackage.querySelector('[data-package-discount]');
    const offerReady = renewPackage.dataset.offerReady === 'true';
    const labels = {
      empty: renewPackage.dataset.labelEmpty,
      one: renewPackage.dataset.labelOne,
      full: renewPackage.dataset.labelFull,
      pending: renewPackage.dataset.labelPending
    };
    const sync = () => {
      const count = Number(Boolean(state.top)) + Number(Boolean(state.bottom));
      progress.textContent = count === 0 ? labels.empty : count === 1 ? labels.one : offerReady ? labels.full : labels.pending;
      review.disabled = count !== 2 || !offerReady;
      const selectedLabels = [state.topLabel, state.bottomLabel].filter(Boolean);
      itemSummary.textContent = selectedLabels.length ? selectedLabels.join(' + ') : renewPackage.dataset.labelEmpty;
      const total = state.topPrice + state.bottomPrice;
      const locale = document.documentElement.lang || 'en-GB';
      const activeCurrency = window.Shopify?.currency?.active || 'GBP';
      const formatted = new Intl.NumberFormat(locale, {style:'currency', currency:activeCurrency}).format(total / 100);
      retailSummary.textContent = total ? formatted : '—';
      discountSummary.textContent = total ? `−${formatted}` : '—';
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      state.lane = tab.dataset.packageTab;
      state.top = null;
      state.bottom = null;
      state.topLabel = '';
      state.bottomLabel = '';
      state.topPrice = 0;
      state.bottomPrice = 0;
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      lanes.forEach((lane) => { lane.hidden = lane.dataset.packageLane !== state.lane; });
      renewPackage.querySelectorAll('[data-package-card]').forEach((card) => card.classList.remove('is-selected'));
      track('select_creator_lane', {creator_lane: state.lane});
      sync();
    }));
    renewPackage.querySelectorAll('[data-package-select]').forEach((button) => button.addEventListener('click', () => {
      const card = button.closest('[data-package-card]');
      const category = card.dataset.category;
      const variantSelect = card.querySelector('[data-package-variant]');
      const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
      const variant = variantSelect.value;
      const activeLane = renewPackage.querySelector(`[data-package-lane="${state.lane}"]`);
      activeLane.querySelectorAll(`[data-category="${category}"]`).forEach((item) => item.classList.remove('is-selected'));
      card.classList.add('is-selected');
      state[category] = variant;
      state[`${category}Label`] = `${card.dataset.productTitle} · ${selectedVariant.textContent.trim()}`;
      state[`${category}Price`] = Number(selectedVariant.dataset.priceCents || 0);
      track(`select_creator_${category}`, {
        creator_lane: state.lane,
        product_name: card.dataset.productTitle,
        variant_id: variant
      });
      sync();
    }));
    review.addEventListener('click', () => {
      if (!state.top || !state.bottom) return;
      storeAttribution();
      track('add_creator_bundle', {creator_lane:state.lane, top_variant_id:state.top, bottom_variant_id:state.bottom});
      document.querySelector('#CreatorBundleCheckout')?.scrollIntoView({behavior:'smooth'});
    });
    track('view_creator_package', attribution);
    sync();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-header"]) return;
  try {
    
  const renewMenuButton = document.querySelector('[data-menu-toggle]');
  const renewMenuDrawer = document.querySelector('[data-menu-drawer]');
  if (renewMenuButton && renewMenuDrawer) {
    renewMenuButton.addEventListener('click', () => {
      const isOpen = renewMenuButton.getAttribute('aria-expanded') === 'true';
      renewMenuButton.setAttribute('aria-expanded', String(!isOpen));
      renewMenuDrawer.hidden = isOpen;
      document.body.classList.toggle('locked', !isOpen);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-product"] && !Shopify.designMode) return;
  try {
    
  const productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    const variantSelect = productRoot.querySelector('[data-variant-select]');
    const price = productRoot.querySelector('[data-product-price]');
    const add = productRoot.querySelector('[data-add-to-cart]');
    const mobilePrice = document.querySelector('[data-mobile-price]');
    const mobileAdd = document.querySelector('[data-mobile-add]');
    variantSelect?.addEventListener('change', (event) => {
      const selected = event.target.options[event.target.selectedIndex];
      const available = selected.dataset.available === 'true';
      price.textContent = selected.dataset.price;
      if (mobilePrice) mobilePrice.textContent = selected.dataset.price;
      [add, mobileAdd].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  } catch(e) { console.error(e); }
})();
})();
